export default {
    integrations_tab_id: 'Id',
    integrations_tab_integration: 'Integration',
    integrations_tab_parameters: 'Parameters',
    integrations_tab_status: 'Status',
    integrations_tab_companies: 'Companies',
    integrations_tab_accounts: 'Accounts',
    integrations_tab_advanced_filters: 'Advanced Filters',
    integrations_tab_apply: 'Apply',
    integrations_tab_tags: 'Tags',
    integrations_tab_active_integrations_only: 'Active Accounts Only',
    integrations_tab_yes: 'Yes',
    integrations_tab_no: 'No',
    integrations_tab_authenticate_cloud: 'Login as Customer',
    integrations_tab_re_sync_backend_information: 'Re-sync Backend Information',
    integrations_tab_devices: 'Devices',
    integrations_tab_package: 'Package',
    integrations_tab_crm: 'Salesforce Id',
    integrations_tab_add_account: 'Add Account',
    integrations_tab_edit: 'Edit',
    integrations_tab_remove_filters: 'Remove filters',
    integrations_tab_account_details: 'Account Details',
    integrations_tab_import_from_p4: 'Import From P4',
    integrations_tab_reprocess_odo_hours: 'Reprocess Odo/Hrs',
    integrations_tab_new_status: 'New Status',
    integrations_tab_at: 'at',
    integrations_tab_next_scheduled_action: 'Next scheduled action on',
    integrations_tab_on: 'on',
    integrations_tab_add_integration: 'Add Integration',
    integrations_tab_external_id: "External Id",
    integrations_tab_title: "Integrations",
    integrations_tab_cerebrumx_permission_error: "You don't have permissions to delete CerebrumX integrations"

};



